export default __webpack_public_path__ + "static/services_01-ae6243fbde7f86333d1613cb7281987f.png";